import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  label: 'Verticals',
  value: '5+'
}, {
  label: 'Workflows Automated',
  value: '100+'
}, {
  label: 'Security',
  value: 'Enterprise-Grade'
}, {
  label: 'Approach',
  value: 'Human-in-the-Loop'
}];
export function TrustSection() {
  return <section className="py-32 bg-[#050505] relative z-10 border-t border-white/5" data-id="element-481">
      <div className="max-w-7xl mx-auto px-6" data-id="element-482">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="mb-24" data-id="element-483">
          <h2 className="font-display text-4xl md:text-5xl text-white tracking-tight" data-id="element-484">
            Why Aijentik.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-16 mb-32" data-id="element-485">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} data-id="element-486">
            <h3 className="text-2xl font-medium text-white mb-6 tracking-tight" data-id="element-487">
              Built for Depth
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-488">
              Every agent is designed around real industry workflows and
              operational nuances. Not generic automation.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} data-id="element-489">
            <h3 className="text-2xl font-medium text-white mb-6 tracking-tight" data-id="element-490">
              Implementation-Ready
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-491">
              Production-grade from day one, built to integrate, govern, and
              scale securely within your environment.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} data-id="element-492">
            <h3 className="text-2xl font-medium text-white mb-6 tracking-tight" data-id="element-493">
              Operational Context
            </h3>
            <p className="text-gray-400 leading-relaxed text-lg" data-id="element-494">
              Understands the rules that matter, compliance, and SLAs. It
              doesn't just generate text; it executes business logic.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-12 pt-16 border-t border-white/5" data-id="element-495">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} data-id="element-496">
              <div className="text-4xl md:text-5xl font-display text-white mb-4 tracking-tight" data-id="element-497">
                {stat.value}
              </div>
              <div className="text-xs text-brand-orange font-medium uppercase tracking-widest" data-id="element-498">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}